<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TimelineMax as Line, Power1 } from 'gsap'

export default {

  name: 'TextWidget',

  props: {
    content: [Object]
  },

  data () {
    return {
      tl: null
    }
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })
      const group = []

      if (this.$refs.title) group.push(this.$refs.title)
      if (this.$refs.content) group.push(this.$refs.content)

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: Power1.easeOut
      }, 0.1)
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.widget
  .widget__content
    .widget__title(v-if="content.title" ref="title") {{ content.title }}
    .widget__main.markdown-container(v-md="content.content" ref="content")
    .widget__main.markdown-container

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.widget
  padding-top 60px
  padding-bottom 60px
  display flex
  justify-content center

  +mobile()
    padding 35px 0

  &__content
    width 780px
    max-width 65vw

    +below(1023px)
      width 100%
      max-width 100%
      padding 0 90px

    +mobile()
      padding 0 30px

  &__title
    padding-bottom 35px
    font-weight 300
    font-size 56px
    line-height 57px
    color blue
    +mobile()
      font-size: 24px;
      line-height: 32px

</style>



// WEBPACK FOOTER //
// text.vue?7116c955